export default {
  "HitPaw Online Audio Extractor": "音频提取",
  "Extract sound from videos with ease.": "提取视频中的声音",
  "Select Audio Format": "选择音频格式",
  "Extract Audio": "提取音频",
  "Extracting Audio": "音频提取中",
  "Extracted Successfully": "提取成功",
  "Extract New": "提取新文件",
  "Extraction Failed": "提取失败",
  "Format": "格式",
};
